import React, {Component} from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import Profile from "./Profile";
import PeopleYouMayKnow from "./PeopleYouMayKnow";
import Addbox from "./Addbox";
import AddboxRight from "./AddboxRight";
import ChatBox from "./ChatBox";
import PostCreate from "./PostCreate";
import Feed from "./Feed";
import PromotionHeader  from "../Promotion/PromotionHeader";
import {changeUserMembership}  from "../../actions/loginAction";
import Remainingpromotion from "../Promotion/PromotionBody/remainingpromotion";

class FeedContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userId        : '',
        userImage     : '',
        userPercentage: 0,
        totalFriend   : 0,
        totalPost     : 0,
        membership    : 'BASIC'
  
      };
    }
    componentDidMount() {
      
      if((window.location.href.includes('item_name=REGISTRATION') == true) && (window.location.href.includes('result=success') == true)){
        let arr = this.props.currentUserDetails;
        arr.user.membership = 'GOLD';
        this.props.changeUserMembership(arr.user);
      }else{
        this.setState({
          userId            : this.props.currentUserDetails.user.id,
          userImage         : this.props.currentUserDetails.user.image,
          membership        : this.props.currentUserDetails.user.membership
          
        })
       
      }

     /*  document.addEventListener('contextmenu', function(event){
        event.preventDefault();
      }) */
      
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
      if(nextProps.currentUserDetails != this.props.currentUserDetails){
        this.setState({
          userImage         : nextProps.currentUserDetails.user.image,
          membership        : nextProps.currentUserDetails.user.membership
        })
      }
  
      this.setState({
        userId            : (Object.keys(nextProps.listOfFeed.listfeed).length > 0) ? nextProps.listOfFeed.listfeed.current_user.user_id : 0,
        userPercentage    : (Object.keys(nextProps.listOfFeed.listfeed).length > 0) ? nextProps.listOfFeed.listfeed.current_user.profile_completion_percentage : 0,
        tototalFriend     : (Object.keys(nextProps.listOfFeed.listfeed).length > 0) ? nextProps.listOfFeed.listfeed.current_user.total_friend : 0,
        totalPost         : (Object.keys(nextProps.listOfFeed.listfeed).length > 0) ? nextProps.listOfFeed.listfeed.current_user.total_post : 0
      })
    }
    render() {
      return (
        <div className="container">
         
           <div className="clr25"></div>
          <div className="content_area">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                <Profile profile_percentage={this.state.userPercentage} profile_image={this.state.userImage} total_post={this.state.totalPost} total_friend={this.state.tototalFriend} membership={this.state.membership} userId={this.state.userId}/>
                <Remainingpromotion />
                <Addbox />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
                {
                  this.state.membership != 'GOLD' ? 
                  <AddboxRight />
                  : null
                }
                
                <ChatBox />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 post_area">
               <div className="row">
                  <PostCreate />
                  <Feed currentUserDetails={this.props.currentUserDetails}/>
                </div>
            </div>
          </div>
        </div>
      );
    }
}

const mapStateToProps = state => {
 
  return {
    listOfFeed         : state.listfeed,
    currentUserDetails : state.login,
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeUserMembership: bindActionCreators(changeUserMembership, dispatch)
  }
}



export default connect(
  mapStateToProps, mapDispatchToProps
)(FeedContainer);

